/*
 * @Author: jordan.lu jordan.lu@oppo.com
 * @Date: 2023-10-31 11:30:43
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-02-02 09:57:06
 * @FilePath: \community-frontend\src\lang\en-GB\page\gallery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    Likes:"Likes",
    Followers:"Followers",
    Threads:'Threads',
    share:'Share',
    barLeft:'Showcase',
    barRight:'Team',
    sortTypeR:'Recommended',
    sortTypeZ:'Most liked',
    sortTypeM:'Latest ', 
    nomore:'No more content ',
    headerTitle:'Ambassadors of the Moment ',
    headerRules:'How it works ', 
    greatTitle:"Meet Our Star Ambassadors",
    greatTips:'Alphabetically arranged rank ', 
    loadText:'Loading',
    ruleTitle:'How it works?',
    rules:'The ranking list will be updated every seven days to count the top three Product Ambassadors who are most creative, engaging and contributive in the Community.',
    all:'All',
    pcRule:'The ranking list will be updated every seven days to count the top three Product Ambassadors who are most creative, engaging and contributive in the Community.',
    gallery: 'Gallery',
    mostInspiring: "The OPPO Factor",
    endRule: "The selection of the Ambassadors who embody the OPPO Factor is based on their top-performing content and the experiences shared with our global friends. We also apply the following formula to complement the selection standard: votes of the Community Members + the views of the content + members inspired + OPPO’s Team score.",
    viewDetails: 'View Details',
    viewOrigin: 'View Origin',
    downOrigin:'Download Original',
    ambassador: "Ambassador's Gallery",
    error: 'Error',
    download: 'Download'
} 